import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-6 bg-black">
          <div className="text-center">
            <p className="text-green-500 font-black text-6xl mb-4">!</p>
            <h1 className="text-2xl font-black text-white mb-2">SOMETHING WENT WRONG</h1>
            <p className="text-white/40 mb-8 text-sm">
              Please refresh the page to try again.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="inline-block px-8 py-4 bg-green-500 text-black font-bold uppercase tracking-wider text-sm hover:bg-green-400 transition-colors duration-300"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
